import {
    request,
    requestPublic
} from './request.js'
export function GetPageList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/UserOperateCount/GetPageList',
        method: 'get',
        params: obj
    })
}
